import {gl_uniform, gl_variable} from '../../definitions/gl/variables.js';
import {gl_mat3} from '../../definitions/gl/matrix.js';
import {gl_vec3, gl_vec2} from '../../definitions/gl/vec.js';

export default superclass => class extends superclass  {
    setup() {
        this.tMatrix = [[1, 0, 0], [0, 1, 0], [0, 0, 1]];
        let name = this.name('globalMatrix', 0);
        this.globalMatrixUniform = gl_uniform({}, () => name);
        this.transformationMatrix = this.globalMatrixUniform([[[1, 0, 0,], [0, 1, 0], [0, 0, 1]]], true);

        this.transformationMatrices = [];
        this.transformationMatricesUniforms = [];
    }

    onPivot(pivot) {
        this.pivot = pivot;
        this.globalPivotUniform([pivot]);
    }

    onTransformationMatrix(mat) {
        // this will be an array of arrays
        // turn them into uniforms and create the transformation
        if (!Array.isArray(mat) && typeof mat === "object") {
            // this is probably a glsl object so we need to replace the transformation matrix
            // with this and then resend the SDFs so that we recompile
            this.userInputMatrix = mat;
            this.onSDFList(this.lastSDFs, true);
            return;
        }

        if (!Array.isArray(mat) || mat.some(s => !Array.isArray(s))) {
            return;
        }

        this.userInputMatrix = undefined;

        this.tMatrix = mat;
        this.globalMatrixUniform([mat]);
    }

    onTransformationList(matrices) {
        let createdUniforms = false;
        window.stopRender= true;
        this.currentTransformations = [... matrices];
        let lastUni, lastValue;
        for (let i=0; i < matrices.length; i++) {
            let matrix = matrices[i];
            if (!Array.isArray(matrix) || !Array.isArray(matrix[0])) {
                continue;
            }
            if (!this.transformationMatrices[i]) {
                // need to create uniform
                let name = this.name("sdfTransform", i);
                this.transformationMatricesUniforms[i] = gl_uniform({}, () => name);
                this.transformationMatrices[i] = this.transformationMatricesUniforms[i]([matrix], true);
                createdUniforms = true;
            } else {
                // otherwise we just update it
                this.transformationMatricesUniforms[i]([matrix]);
            }
            lastUni = this.transformationMatricesUniforms[i];
            lastValue = matrix;
        }


        window.stopRender = false;

        if (lastUni) {
            lastUni([lastValue]);
        }

        if (createdUniforms) {
            // since we created a uniform, we need to recompile
            this.onSDFList(this.lastSDFs, true);
        }
        this.sendTransformedPositions();
    }

    sendTransformedPositions() {
        if (!this.currentTransformations) {
            return;
        }
        let transformed = [];
        let index=0;
        for (let [x,y,z] of this.positions) {
            let transformation=this.currentTransformations[index];
            if (!transformation) {
                return;
            }
            let [a,b,c] = transformation;
            transformed.push(
                [x*a[0]+y*a[1]+z*a[2],
                 x*b[0]+y*b[1]+y*b[2],
                 x*c[0]+y*c[1]+z*c[2]]);
            index++;
        }
        this.sendMessage("Transformed Positions", transformed);
    }

}
